import * as angular from 'angular';
import { SupportDuplicationComponent } from './support-duplicator.component';

export const SupportDuplicatorModule = angular
  .module('supportDuplicatorModule', [])
  .component('supportDuplicator', SupportDuplicationComponent).name;
